import { RouteObject, Outlet } from "react-router-dom";

import ForgotPassword from "@/features/auth/pages/forgot-password";
import Login from "@/features/auth/pages/login";
import Register from "@/features/auth/pages/register";
import RegisterIdForm from "@/features/auth/forms/register-id-form";
import RegisterPersonalForm from "@/features/auth/forms/register-personal-form";
import RegisterBusinessForm from "@/features/auth/forms/register-business-form";
import RegisterVerificationForm from "@/features/auth/forms/register-verification-form";
import RegisterFinishForm from "@/features/auth/forms/register-finish";
// import ResetPassword from "@/features/auth/pages/reset-password";
// import VerifyOtp from "@/features/auth/pages/verify-otp";


const routes: RouteObject = {
    path: "/auth",
    element: <Outlet />,
    children: [
        {
            index: true,
            element: <Login />,
        },
        {
            path: "/auth/login",
            element: <Login />,
        },
        {
            path: "/auth/register",
            element: <Register />,
            children: [
                {
                    path: "personal",
                    element: <RegisterPersonalForm />,
                },
                {
                    path: "identity",
                    element: <RegisterIdForm />,
                },
                {
                    path: "business",
                    element: <RegisterBusinessForm />,
                },
                {
                    path: "verification",
                    element: <RegisterVerificationForm />,
                },
                {
                    path: "welcome",
                    element: <RegisterFinishForm />,
                },
            ]
        },
        {
            path: "/auth/forgot-password",
            element: <ForgotPassword />,
        },
        // {
        //     path: "/auth/verify-otp",
        //     element: <VerifyOtp />,
        // },
        // {
        //     path: "/auth/reset-password",
        //     element: <ResetPassword />,
        // },
    ]
}

export default routes